<div fxLayout="column">
	<div *ngFor="let item of contractInfo.contractServiceTypeCheckItemValues" fxLayout="row">
		<div fxLayout="row" fxFlex class="item" fxLayoutAlign="start center">
			<span fxFlex class="text">{{ item.text }}</span>
			<span fxFlex="50px" class="item-yes" [ngClass]="{active: item.value }">Yes</span>
			<span fxFlex="50px" class="item-no" [ngClass]="{active: !item.value }">No</span>
		</div>
	</div>
</div>